import React from 'react';
import { CProgress } from '@coreui/react';

const StepsWidget = ({ steps }) => (
  <div>
    <div className="mb-2">Steps Today</div>
    <strong>{steps} steps</strong>
    <CProgress className="CProgress-xs mt-2" color="success" value={(steps / 10000) * 100} />
  </div>
);

export default StepsWidget;


